import Texture2D from '../webgl/texture-2d';
import TextureCube from '../webgl/texture-cube';
import Texture3D from '../webgl/texture-3d';
import assert from 'assert'; // Clone a new texture object from a reference texture object.

export function cloneTextureFrom(refTexture, overrides) {
  assert(refTexture instanceof Texture2D || refTexture instanceof TextureCube || refTexture instanceof Texture3D);
  var TextureType = refTexture.constructor;
  var gl = refTexture.gl,
      width = refTexture.width,
      height = refTexture.height,
      format = refTexture.format,
      type = refTexture.type,
      dataFormat = refTexture.dataFormat,
      border = refTexture.border,
      mipmaps = refTexture.mipmaps;
  var textureOptions = Object.assign({
    width: width,
    height: height,
    format: format,
    type: type,
    dataFormat: dataFormat,
    border: border,
    mipmaps: mipmaps
  }, overrides); // TODO: move this to `Texture` class as instance method and use this.constructor

  return new TextureType(gl, textureOptions);
}
//# sourceMappingURL=texture-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/webgl-utils/texture-utils.js
// module id = 1607
// module chunks = 0